var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.334 38C30.2751 38 38.334 29.9411 38.334 20C38.334 10.0589 30.2751 2 20.334 2C10.3929 2 2.33398 10.0589 2.33398 20C2.33398 29.9411 10.3929 38 20.334 38Z",
    stroke: "#FCAF33",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.834 14.5376C15.834 13.6785 15.834 13.2489 16.0135 13.0091C16.17 12.8001 16.4095 12.6694 16.6699 12.6508C16.9687 12.6294 17.33 12.8617 18.0527 13.3263L26.5497 18.7887C27.1768 19.1918 27.4904 19.3934 27.5987 19.6497C27.6933 19.8736 27.6933 20.1264 27.5987 20.3503C27.4904 20.6066 27.1768 20.8082 26.5497 21.2113L18.0527 26.6737C17.33 27.1383 16.9687 27.3706 16.6699 27.3492C16.4095 27.3306 16.17 27.1999 16.0135 26.9909C15.834 26.7511 15.834 26.3215 15.834 25.4624V14.5376Z",
    stroke: "#FCAF33",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlay);
export default __webpack_public_path__ + "static/media/circle-play.69636a0d2cb3545c00ca1139afb90605.svg";
export { ForwardRef as ReactComponent };